export const automation_config_defaults: any = {
  VISITS: {
    confirmation: { when: { placeholder: "not used", displayOnly: true } },
    reminder1: { when: { value: "days=-3" } },
    reminder2: { when: { value: "days=-1" } },
    reminder3: { when: { value: "hours=-2" } },
    reminder_sms: { when: { value: "hours=-2" } },
    after_appointment: { when: { value: "days=+1" } },
    reserved: { when: { value: "days=+1" } },
    in_option: { when: { value: "days=+1" } },
    sales_agreement: { when: { value: "days=+1" } },
    rental_agreement: { when: { value: "days=+1" } },
  },
  INBOUNDLEADS: {
    confirmation: { when: { placeholder: "not used", displayOnly: true } },
  },
  DEAL: {
    reserved: { when: { placeholder: "not used", displayOnly: true } },
    in_option: { when: { placeholder: "not used", displayOnly: true } },
    sales_agreement: { when: { placeholder: "not used", displayOnly: true } },
    rental_agreement: { when: { placeholder: "not used", displayOnly: true } },
    review: { when: { placeholder: "not used", displayOnly: true } },
    after_sales_agreement: { when: { value: "months=+4" } },
    follow_up_deed: { when: { value: "days=+1" } },
    follow_up_deed2: { when: { value: "days=+1" } },
  },
  INVALID_DATA: {
    warning: { when: { placeholder: "not used", displayOnly: true } },
  },
};
